<template>
  <b-modal
    modal-class="component-modal-caries-risk-assesment"
    ref="CariesRisk"
    :lazy="true"
    size="fluid"
    header-class="py-2"
    title="ประเมินความเสียงฟันผุ"
    no-close-on-backdrop
    no-close-on-esc
    scrollable
    @hidden="defaultValue"
  >
    <b-table-simple small responsive>
      <b-thead head-variant="dark">
        <b-tr>
          <b-th>ปัจจัยสาเหตุ</b-th>
          <b-th
            ><b-row
              ><b-col cols="4"></b-col><b-col cols="4"></b-col
              ><b-col cols="4" class="px-0"></b-col></b-row
          ></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="q in questions"
          :key="q.id"
          :variant="q.type === 'header' ? 'secondary' : ''"
        >
          <b-th v-if="q.type === 'header'" colspan="2">
            {{ q.text }}
          </b-th>

          <b-td v-else>{{ q.text }} </b-td>
          <b-td>
            <b-form-radio-group v-model="answers[q.id]"
              ><b-row
                ><b-col cols="4" v-for="(value, key) in q.answer" :key="key">
                  <b-form-radio :value="key">{{ value }}</b-form-radio>
                </b-col></b-row
              ></b-form-radio-group
            ></b-td
          >
        </b-tr>
      </b-tbody>
      <b-tfoot foot-variant="light">
        <b-tr>
          <b-th>สรุปผลการประเมิน: มีความเสี่ยงโรคฟันผุอยู่ในระดับ</b-th>
          <b-th v-if="evaluationScore === 'high'" class="text-danger">สูง</b-th>
          <b-th v-else-if="evaluationScore === 'medium'" class="text-warning"
            >ปานกลาง</b-th
          >
          <b-th v-else-if="evaluationScore === 'low'" class="text-success"
            >ต่ำ</b-th
          >
          <b-th v-else class="">N/A</b-th>
        </b-tr>
      </b-tfoot>
    </b-table-simple>

    <!-- Printable A4 sheet. Hidden on screen; PdfExport clones these nodes. -->
    <div class="d-none">
      <div ref="printHeader">
        <table style="width: 100%; border-collapse: collapse">
          <tr>
            <td v-if="logo" style="width: 110px; vertical-align: middle">
              <img :src="logo" :alt="clinic.name" style="height: 80px" />
            </td>
            <td style="vertical-align: middle">
              <h4 style="margin: 0 0 4px 0">{{ clinic.name }}</h4>
              <p
                v-if="branchInfo && branchInfo.address"
                style="margin: 0 0 2px 0; font-size: 11px"
              >
                {{ branchInfo.address }}
              </p>
              <p style="margin: 0; font-size: 11px">
                <span v-if="branchInfo && branchInfo.tel"
                  >โทร: {{ branchInfo.tel }}</span
                >
                <span v-if="branchInfo && branchInfo.line" style="margin-left: 16px"
                  >Line ID: {{ branchInfo.line }}</span
                >
              </p>
            </td>
          </tr>
        </table>
        <hr style="margin: 6px 0 0 0" />
      </div>

      <div ref="printBody" style="font-size: 11px">
        <h5 style="text-align: center; margin: 10px 0 12px 0">
          ใบประเมินความเสี่ยงฟันผุ
        </h5>

        <table style="width: 100%; border-collapse: collapse; margin-bottom: 8px">
          <tr>
            <td style="width: 50%; padding: 1px 0">
              <strong>ชื่อผู้ป่วย:</strong> {{ ptFullname || "-" }}
            </td>
            <td style="width: 50%; padding: 1px 0">
              <strong>DN:</strong> {{ patient.dn || "-" }}
            </td>
          </tr>
          <tr>
            <td style="padding: 1px 0">
              <strong>วันที่ประเมิน:</strong> {{ report.assessedDate }}
            </td>
            <td style="padding: 1px 0">
              <strong>วันที่แก้ไข:</strong> {{ report.modifiedDate }}
            </td>
          </tr>
        </table>

        <table
          style="width: 100%; border-collapse: collapse; table-layout: fixed"
        >
          <thead>
            <tr style="background-color: #343a40; color: #ffffff">
              <th :style="cellStyle + 'width: 55%'">ปัจจัยสาเหตุ</th>
              <th :style="cellStyle + 'width: 30%'">คำตอบ</th>
              <th :style="cellStyle + 'width: 15%; text-align: center'">
                ระดับความเสี่ยง
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(row, index) in report.rows">
              <tr
                v-if="row.type === 'header'"
                :key="`h-${index}`"
                style="background-color: #e9ecef"
              >
                <td :style="cellStyle + 'font-weight: bold'" colspan="3">
                  {{ row.text }}
                </td>
              </tr>
              <tr v-else :key="`q-${row.id}`">
                <td :style="cellStyle">{{ row.text }}</td>
                <td :style="cellStyle">{{ row.answerText }}</td>
                <td :style="cellStyle + 'text-align: center'">
                  {{ row.riskText }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>

        <table
          style="
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
            border: 1px solid #343a40;
          "
        >
          <tr>
            <td :style="cellStyle + 'border: 0; font-weight: bold'">
              สรุปผลการประเมิน: มีความเสี่ยงโรคฟันผุอยู่ในระดับ
            </td>
            <td
              :style="
                cellStyle +
                'border: 0; text-align: center; width: 20%; font-weight: bold; font-size: 13px'
              "
            >
              {{ report.overallRiskText }}
            </td>
          </tr>
        </table>
      </div>

      <div ref="printFooter"></div>
    </div>

    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="secondary"
          class="float-left"
          @click="$refs['CariesRisk'].hide()"
        >
          ปิด
        </b-button>
        <b-button
          :variant="isAnswer ? 'warning' : 'primary'"
          class="float-right"
          @click="createRiskAssesment"
        >
          {{ isAnswer ? "แก้ไข" : "บันทึก" }}
        </b-button>
        <b-button
          variant="info"
          class="float-right mr-2"
          :disabled="!canPrint"
          :title="
            canPrint ? '' : 'บันทึกผลการประเมินก่อนจึงจะพิมพ์ได้'
          "
          @click="printAssessment"
        >
          พิมพ์
        </b-button>
      </div>
    </template>

    <PdfExport ref="pdfExport" />
    <Loading v-if="isLoading"></Loading>
    <Dialog ref="Dialog"></Dialog>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Loading from "@/components/Loading";
// import PatientProfile from "@/components/PatientProfile";
import Dialog from "@/components/modal/Dialog";
import PdfExport from "@/components/PdfExport";
import cariesRiskReport from "@/utils/cariesRiskReport";
import { required, requiredIf } from "vuelidate/lib/validators";

import { eventBus } from "../../main";

export default {
  name: "CariesRisk",
  components: {
    // PatientProfile,
    Loading,
    Dialog,
    PdfExport,
  },
  props: {},
  validations: {},

  data() {
    return {
      questions: [],
      answers: {},
      patient: {},
      patientId: null,
      riskQuestionsId: null,
      answersId: null,
      creationDt: null,
      modifyDt: null,
      // Snapshot of the answers as loaded, so printing can warn when the sheet
      // would show edits that are not in the saved record the dates refer to.
      savedAnswersKey: null,

      // Shared by every printed table cell; html2canvas is more reliable with
      // inline styles than with classes that live in scoped stylesheets.
      cellStyle:
        "border: 1px solid #adb5bd; padding: 2px 4px; vertical-align: top;",

      isLoading: false,
    };
  },

  created() {
    this.init();
  },
  mounted() {},
  watch: {},
  computed: {
    ...mapGetters({
      branchInfo: "moduleUser/getBranchInfo",
      viewFile: "moduleContent/viewFile",
    }),
    evaluationScore() {
      if (Object.keys(this.answers).length < 13) return "N/A";
      if (Object.values(this.answers).indexOf("high") > -1) return "high";
      if (Object.values(this.answers).indexOf("medium") > -1) return "medium";
      return "low";
    },
    isAnswer() {
      return this.answersId > 0;
    },
    // Only a saved record carries the assessment/modified dates the sheet needs.
    canPrint() {
      return this.isAnswer && !!this.creationDt;
    },
    hasUnsavedChanges() {
      return (
        this.savedAnswersKey !== null &&
        this.savedAnswersKey !== JSON.stringify(this.answers)
      );
    },
    clinic() {
      return this.branchInfo?.clinic || {};
    },
    logo() {
      const logoId = this.branchInfo?.clinic?.logo;
      return logoId ? this.viewFile(logoId) : null;
    },
    ptFullname() {
      return [
        this.patient?.titleNameTh,
        this.patient?.firstNameTh,
        this.patient?.lastNameTh,
      ]
        .filter(i => i)
        .join(" ");
    },
    report() {
      return cariesRiskReport({
        questions: this.questions,
        answers: this.answers,
        creationDt: this.creationDt,
        modifyDt: this.modifyDt,
      });
    },
  },
  methods: {
    ...mapActions({
      fetchQuestions: "moduleCariesRiskAssessment/fetchQuestions",
      fetchAnswers: "moduleCariesRiskAssessment/fetchAnswers",
      createAnswers: "moduleCariesRiskAssessment/createAnswers",
      updateAnswers: "moduleCariesRiskAssessment/updateAnswers",
    }),
    init() {},
    async show(patientId, patient) {
      try {
        this.isLoading = true;
        this.patientId = patientId;
        this.patient = patient || {};
        const res = await this.fetchAnswers({
          patientID: this.patientId,
        });
        const answers = res.data;
        this.answersId = answers?.id;
        if (answers?.id) {
          this.questions = answers.questions;
          this.riskQuestionsId = answers.riskQuestionsId;
          this.answers = this.convertAnswerToObj(answers.answers);
          this.creationDt = answers.creationDt;
          this.modifyDt = answers.modifyDt;
          this.savedAnswersKey = JSON.stringify(this.answers);
          return;
        } else {
          const { id, questions } = await this.fetchQuestions({
            id: this.answers?.riskQuestionsId,
          });
          this.riskQuestionsId = id;
          this.questions = questions;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
        await this.$nextTick();
        this.$refs["CariesRisk"].show();
      }
    },
    convertAnswerToObj(array) {
      return array.reduce(
        (obj, item) => Object.assign(obj, { [item.questionId]: item.value }),
        {}
      );
    },
    async createRiskAssesment() {
      if (Object.keys(this.answers).length < 13) {
        this.$refs.Dialog.showAlertInfo(
          "ตอบคำถามไม่ครบ",
          "กรุณาตอบให้ครบทุกคำถาม",
          "warning"
        );
        return;
      }
      const res = await this.$refs.Dialog.showAlertConfirm(
        `ประเมินความเสี่ยง "${this.evaluationText()}"`,
        "คุณต้องการบันทึกประเมินความเสี่ยง ?"
      );
      if (res.isConfirmed) {
        try {
          this.isLoading = true;
          let data = this.formatAnswers();
          if (this.isAnswer) {
            const res = await this.updateAnswers({ data });
            eventBus.$emit("alertToast", {
              message: "แก้ไขประเมินความเสี่ยงฟันผุสำเร็จ",
              variant: "success",
            });
          } else {
            const res = await this.createAnswers({ data });
            eventBus.$emit("alertToast", {
              message: "บันทึกประเมินความเสี่ยงฟันผุสำเร็จ",
              variant: "success",
            });
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.isLoading = false;
          await this.$nextTick();
          this.$refs["CariesRisk"].hide();
        }
      }
    },

    async printAssessment() {
      if (this.hasUnsavedChanges) {
        const confirm = await this.$refs.Dialog.showAlertConfirm(
          "ยังไม่ได้บันทึกการแก้ไข",
          "ใบพิมพ์จะแสดงคำตอบบนหน้าจอ แต่วันที่แก้ไขจะเป็นของข้อมูลที่บันทึกไว้ ต้องการพิมพ์ต่อหรือไม่ ?"
        );
        if (!confirm.isConfirmed) return;
      }
      try {
        this.isLoading = true;
        await this.$nextTick();
        await this.$refs.pdfExport.generatePdf({
          header: this.$refs.printHeader,
          body: this.$refs.printBody,
          footer: this.$refs.printFooter,
          option: {
            filename: `Caries_Risk_${this.patient?.dn || this.patientId}`,
            fontSize: "11px",
          },
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },

    formatAnswers() {
      let formattedAnswers = [];
      for (let [id, value] of Object.entries(this.answers)) {
        formattedAnswers.push({
          questionId: Number(id),
          value,
        });
      }
      formattedAnswers.sort((a, b) => a.questionId - b.questionId);
      return {
        id: this.answersId,
        patientId: this.patientId,
        riskQuestionsId: this.riskQuestionsId,
        evaluationScore: this.formatEvaluationScore(),
        answers: formattedAnswers,
      };
    },
    formatEvaluationScore() {
      switch (this.evaluationScore) {
        case "low":
          return 1;
        case "medium":
          return 2;
        case "high":
          return 3;
      }
    },
    evaluationText() {
      switch (this.evaluationScore) {
        case "low":
          return "ต่ำ";
        case "medium":
          return "กลาง";
        case "high":
          return "สูง";
      }
    },
    defaultValue() {
      this.answers = [];
      this.questions = [];
      this.patient = {};
      this.patientId = null;
      this.riskQuestionsId = null;
      this.answersId = null;
      this.creationDt = null;
      this.modifyDt = null;
      this.savedAnswersKey = null;
    },
  },
};
</script>

<style>
</style>
